import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "elementor-form-fields-wrapper elementor-labels-" }
const _hoisted_3 = { class: "elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-33" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-field-email",
  class: "elementor-field-label elementor-screen-only"
}, "E-Mail-Adresse", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "elementor-field-type-select elementor-field-group elementor-column elementor-field-group-field_c2d0c87 elementor-col-33" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-field-field_c2d0c87",
  class: "elementor-field-label elementor-screen-only"
}, " Newsletter ", -1)
const _hoisted_8 = { class: "elementor-field elementor-select-wrapper" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Bitte wählen ...", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  label: "Regionale Newsletter:"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "elementor-field-group elementor-column elementor-field-type-submit e-form__buttons elementor-col-33" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "elementor-button-icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "elementor-button-text" }, "Newsletter abonnieren")
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.renderFlag)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "elementor-form",
          method: "post",
          name: "Newsletter-Anmeldung",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent","stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                disabled: _ctx.success,
                style: _normalizeStyle(_ctx.styles),
                size: "1",
                type: "text",
                name: "form_fields[email]",
                id: "form-field-email",
                class: "elementor-field elementor-size-lg elementor-field-textual",
                placeholder: "Deine E-Mail-Adresse"
              }, null, 12, _hoisted_5), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.target) = $event)),
                  disabled: _ctx.success,
                  name: "form_fields[field_c2d0c87]",
                  id: "form-field-field_c2d0c87",
                  class: "elementor-field-textual elementor-size-lg",
                  style: {"color":"#ffffff"}
                }, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetsOther, (target) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: target.value,
                      value: target.value
                    }, _toDisplayString(target.label), 9, _hoisted_11))
                  }), 128)),
                  (_ctx.targetsRegion.length > 0)
                    ? (_openBlock(), _createElementBlock("optgroup", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetsRegion, (target) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: target.value,
                            value: target.value
                          }, _toDisplayString(target.label), 9, _hoisted_13))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9), [
                  [_vModelSelect, _ctx.target]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.success,
                style: _normalizeStyle(_ctx.styles),
                class: "elementor-button elementor-size-sm"
              }, _hoisted_17, 12, _hoisted_15)
            ])
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}